import React from 'react'

import Base from './Select'

const Select = ({placeholder, ...others}) =>
  <Base
    placeholder={placeholder || 'Select a role...'}
    options={[
      {key: 'ADMIN', label: 'Admin', value: 'ADMIN'},
      {key: 'SALES', label: 'Sales Rep', value: 'SALES'},
      {key: 'CLIENT', label: 'Client', value: 'CLIENT'}
    ]}
    {...others}
  />

  export default Select


// WEBPACK FOOTER //
// ./src/components/RoleSelect.js